import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from '../../../../core/models/general/body-list-response';
import { EvaluacionResultadoCoevaluacionConsolidadoDTO } from '../../../../core/models/evaluacion/evaluacionResultadoCoevaluacionConsolidado-DTO';
import { BodyResponse } from '../../../../core/models/general/body-response';

const API_URL = environment.apiUrlEvaluacion;

@Injectable()
export class EvaluacionResultadoCoevaluacionConsolidadoService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getEvaluacionResultadoCoevaluacionConsolidadoService() {
        return this.http.get<BodyListResponse<EvaluacionResultadoCoevaluacionConsolidadoDTO>>(
            API_URL + '/api/v1/resultadoCoevaluacionConsolidado/todos'
        );
    }

    guardarEvaluacionResultadoCoevaluacionConsolidadoService(evaluacionResultadoCoevaluacionConsolidadoDTO: EvaluacionResultadoCoevaluacionConsolidadoDTO) {
        return this.http.post(API_URL + '/api/v1/resultadoCoevaluacionConsolidado', evaluacionResultadoCoevaluacionConsolidadoDTO);
    }

    getEvaluacionResultadoCoevaluacionConsolidadoPorCodigoResultadoConService(codigoResultadoCon: String) {
        return this.http.get<BodyResponse<EvaluacionResultadoCoevaluacionConsolidadoDTO>>(
            API_URL + '/api/v1/resultadoCoevaluacionConsolidado/' + codigoResultadoCon
        );
    }
}
